export function shouldHardReload(err) {
  const msg = String(
    err?.message ??
    err?.reason?.message ??
    err?.reason ??
    err ?? ''
  );
  return /Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS|CSS chunk load failed|Loading chunk \d+ failed|Load failed/i.test(msg);
}

export async function handleHardReload(url) {
  const sep = url.includes('?') ? '&' : '?';
  const bust = `_cb=${Date.now()}`;
  const target = `${url}${sep}${bust}`;

  window.location.replace(target);
}

export async function handleHardReloadIframe(url) {
  const sep = url.includes('?') ? '&' : '?';
  const bust = `_cb=${Date.now()}`;
  const target = `${url}${sep}${bust}`;

  window.location.replace(target);
}

export function saveDesiredRouteAfterLogin(routeFullPath, routeName, routeMetadata, routeParams) {
  const routeSnapshot = {
    fullPath: routeFullPath,
    name: routeName,
    meta: routeMetadata,
    params: routeParams
  };
  sessionStorage.setItem('desiredRouteAfterLogin', JSON.stringify(routeSnapshot));
}

export function salesUserHasAccessToRoute(routeName) {
  const salesUserAllowedRoutes = ['sold-reassign-user', 'reassign-user', 'reassign-brand'];
  return salesUserAllowedRoutes.includes(routeName);
}

export function assigneeUserHasAccessToRoute(routeName) {
  const assigneeUserAllowedRoutes = ['edit-lead', 'sale-lead', 'ship-lead', 'no-sale-lead', 'opportunity', 'introduction', 'progress-notes', 'reassign-user', 'reassign-brand'];
  return assigneeUserAllowedRoutes.includes(routeName);
}

export function originatorUserHasAccessToRoute(routeName) {
  const originatorUserAllowedRoutes = ['edit-lead', 'opportunity-details', 'validate-lead', 'invalidate-lead', 'sold-reassign-user', 'reassign-user', 'reassign-brand'];
  return originatorUserAllowedRoutes.includes(routeName);
}
